import './App.css';
import AdCreative from "./AdCreative";
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

function MarketplaceCampaignPreview({ campaign }) {
    const navigate = useNavigate();

    const e6 = 100000;
    const [shouldPlay, setShouldPlay] = useState(false);

    return (
        <div
            className='marketplace-preview-campaign'
            onClick={
                () => {
                    navigate(`/campaign/?campaign_id=${campaign.id}`);
                }
            }
        >
            <div
                style={{
                    width: '10em',
                    marginRight: '1em',
                    height: '8em',
                    // borderColor: 'green',
                    // borderStyle: 'solid',
                    backgroundColor: 'black',
                    display: 'flex',
                    alignItems: 'center',
                }}
                onMouseEnter={
                    () => {
                        setShouldPlay(true);
                    }
                }
                onMouseLeave={
                    () => {
                        setShouldPlay(false);
                    }
                }
             
            >
                <AdCreative
                    creativeURL={campaign.creative_url}
                    creativeExt={campaign.creative_ext}
                    hideControls={true}
                    isMuted={true}
                    objectFit='contain'
                    width='100%'
                    height='100%'
                    shouldAutoPlay={shouldPlay}
                />
            </div>
            <div style={{ marginTop: '0.5em', width: '10em' }}>
                <div
                    style={{
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {campaign.title}
                </div>
                <div style={{ marginTop: '0.5em' }}>
                    <b>
                        {
                            campaign.max_price_per_second_e6 > 0 &&
                            <div>
                                up to {(campaign.max_price_per_second_e6 / e6 * 3600).toFixed(2)} EUR/h
                            </div>
                        }
                        {
                            Number(campaign.max_price_per_second_e6) == 0 &&
                            <div>
                                FREE
                            </div>
                        }
                    </b>
                </div>
            </div>
        </div >
    )
}

export default MarketplaceCampaignPreview;